"use strict";

var _possibleConstructorReturn = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_transformer_1 = require("class-transformer");

var class_validator_1 = require("class-validator");

var objectProductType_1 = require("../enum/objectProductType");

var productType_1 = require("../enum/productType");

var queryDecorator_1 = require("../queryDecorator");

var validationCountryCode_1 = require("../validationCountryCode");

var brand_1 = require("./brand");

var designer_1 = require("./designer");

var objectProduct_1 = require("./objectProduct");

var pagination_1 = require("./pagination");

var productDocument_1 = require("./productDocument");

var productEshop_1 = require("./productEshop");

var productPicture_1 = require("./productPicture");

var productPreview_1 = require("./productPreview");

var productSourceFile_1 = require("./productSourceFile");

var surfaceProduct_1 = require("./surfaceProduct");

var tag_1 = require("./tag");

var objectProductModelBundle_1 = require("./objectProductModelBundle");

var objectProductVariation_1 = require("./objectProductVariation");

var objectProductDimension_1 = require("./objectProductDimension");

var ProductCorrectionScale = function ProductCorrectionScale() {
  _classCallCheck(this, ProductCorrectionScale);
};

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductCorrectionScale.prototype, "unitFactor", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductCorrectionScale.prototype, "factor", void 0);

exports.ProductCorrectionScale = ProductCorrectionScale;
var ProductOrderEnum;

(function (ProductOrderEnum) {
  ProductOrderEnum["name"] = "name";
  ProductOrderEnum["enabled"] = "enabled";
  ProductOrderEnum["collection"] = "collection";
  ProductOrderEnum["brandCode"] = "brandCode";
  ProductOrderEnum["brandWebsiteUrl"] = "brandWebsiteUrl";
  ProductOrderEnum["type"] = "type";
  ProductOrderEnum["createdAt"] = "createdAt";
  ProductOrderEnum["updatedAt"] = "updatedAt";
  ProductOrderEnum["deletedAt"] = "deletedAt";
  ProductOrderEnum["state"] = "state";
  ProductOrderEnum["promoted"] = "promoted";
  ProductOrderEnum["download"] = "download";
  ProductOrderEnum["view"] = "view";
  ProductOrderEnum["countUnresolvedProblem"] = "countUnresolvedProblem";
})(ProductOrderEnum = exports.ProductOrderEnum || (exports.ProductOrderEnum = {}));

var ProductFilterDTO = function ProductFilterDTO() {
  _classCallCheck(this, ProductFilterDTO);
};

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductFilterDTO.prototype, "name", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductFilterDTO.prototype, "enabled", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductFilterDTO.prototype, "deleted", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductFilterDTO.prototype, "onlyVisible", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductFilterDTO.prototype, "haveObjectProductModelBundle", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductFilterDTO.prototype, "have3DObject", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductFilterDTO.prototype, "haveThumbnail", void 0);

__decorate([queryDecorator_1.TransformToBoolean(), class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductFilterDTO.prototype, "promoted", void 0);

__decorate([class_validator_1.IsOptional(), queryDecorator_1.TransformToArray(), class_validator_1.IsEnum(productType_1.ProductType, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "types", void 0);

__decorate([class_validator_1.IsOptional(), queryDecorator_1.TransformToArray(), class_validator_1.IsEnum(objectProductType_1.ObjectProductType, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "objectProductTypes", void 0);

__decorate([queryDecorator_1.TransformToNumber(), class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductFilterDTO.prototype, "priceMin", void 0);

__decorate([queryDecorator_1.TransformToNumber(), class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductFilterDTO.prototype, "priceMax", void 0);

__decorate([queryDecorator_1.TransformToNumber(), class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductFilterDTO.prototype, "widthMin", void 0);

__decorate([queryDecorator_1.TransformToNumber(), class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductFilterDTO.prototype, "widthMax", void 0);

__decorate([queryDecorator_1.TransformToNumber(), class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductFilterDTO.prototype, "heightMin", void 0);

__decorate([queryDecorator_1.TransformToNumber(), class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductFilterDTO.prototype, "heightMax", void 0);

__decorate([queryDecorator_1.TransformToNumber(), class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductFilterDTO.prototype, "depthMin", void 0);

__decorate([queryDecorator_1.TransformToNumber(), class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductFilterDTO.prototype, "depthMax", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "productIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "designerIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "styleTagIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "roomTagIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "colorTagIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "materialTagIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "brandIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "projectSceneVersionIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "projectIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "objectProductCategoryIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "objectProductCategoryParentIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "accountIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), class_validator_1.IsString({
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "stateIds", void 0);

__decorate([queryDecorator_1.TransformToArray(), class_validator_1.IsOptional(), validationCountryCode_1.IsCountryCode({
  each: true
}), __metadata("design:type", Array)], ProductFilterDTO.prototype, "madeIn", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductFilterDTO.prototype, "collection", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductFilterDTO.prototype, "query", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductFilterDTO.prototype, "brandCode", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(), __metadata("design:type", String)], ProductFilterDTO.prototype, "visualSearchId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(), __metadata("design:type", String)], ProductFilterDTO.prototype, "textureMatchingId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductFilterDTO.prototype, "details", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductFilterDTO.prototype, "countUnresolvedProblem", void 0);

exports.ProductFilterDTO = ProductFilterDTO;

var ProductDTO = function ProductDTO() {
  _classCallCheck(this, ProductDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ProductDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsEnum(productType_1.ProductType), __metadata("design:type", String)], ProductDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return objectProduct_1.ObjectProductDTO;
}), __metadata("design:type", objectProduct_1.ObjectProductDTO)], ProductDTO.prototype, "objectProduct", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return surfaceProduct_1.SurfaceProductDTO;
}), __metadata("design:type", surfaceProduct_1.SurfaceProductDTO)], ProductDTO.prototype, "surfaceProduct", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductDTO.prototype, "details", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductDTO.prototype, "collection", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductDTO.prototype, "brandCode", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUrl({
  require_protocol: true,
  require_valid_protocol: true
}), __metadata("design:type", String)], ProductDTO.prototype, "brandWebsiteUrl", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductDTO.prototype, "suggestedPrice", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsDate(), __metadata("design:type", Date)], ProductDTO.prototype, "designedDate", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductDTO.prototype, "designersValidated", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductDTO.prototype, "haveObjectProductModelBundle", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductDTO.prototype, "countUnresolvedProblem", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductDTO.prototype, "promoted", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductDTO.prototype, "stateId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(), __metadata("design:type", String)], ProductDTO.prototype, "chosenSourceFileId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return brand_1.BrandLightDTO;
}), __metadata("design:type", brand_1.BrandLightDTO)], ProductDTO.prototype, "brand", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureDTO;
}), __metadata("design:type", productPicture_1.ProductPictureDTO)], ProductDTO.prototype, "thumbnail", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ProductDTO.prototype, "createdAt", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ProductDTO.prototype, "updatedAt", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsDate(), __metadata("design:type", Date)], ProductDTO.prototype, "deletedAt", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productEshop_1.ProductEshopDTO;
}), __metadata("design:type", Array)], ProductDTO.prototype, "productEshops", void 0);

exports.ProductDTO = ProductDTO;

var ProductLightDTO = function ProductLightDTO() {
  _classCallCheck(this, ProductLightDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ProductLightDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLightDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLightDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLightDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLightDTO.prototype, "collection", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLightDTO.prototype, "brandCode", void 0);

__decorate([class_validator_1.IsUrl({
  require_protocol: true,
  require_valid_protocol: true
}), __metadata("design:type", String)], ProductLightDTO.prototype, "brandWebsiteUrl", void 0);

__decorate([class_validator_1.IsEnum(productType_1.ProductType), __metadata("design:type", String)], ProductLightDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ProductLightDTO.prototype, "designedDate", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductLightDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductLightDTO.prototype, "promoted", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductLightDTO.prototype, "details", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductLightDTO.prototype, "suggestedPrice", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(), __metadata("design:type", String)], ProductLightDTO.prototype, "objectProductId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(objectProductType_1.ObjectProductType), __metadata("design:type", String)], ProductLightDTO.prototype, "objectProductType", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(), __metadata("design:type", String)], ProductLightDTO.prototype, "surfaceProductId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureDTO;
}), __metadata("design:type", productPicture_1.ProductPictureDTO)], ProductLightDTO.prototype, "thumbnail", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return brand_1.BrandLightDTO;
}), __metadata("design:type", brand_1.BrandLightDTO)], ProductLightDTO.prototype, "brand", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLightDTO.prototype, "stateId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(), __metadata("design:type", String)], ProductLightDTO.prototype, "chosenSourceFileId", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ProductLightDTO.prototype, "createdAt", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ProductLightDTO.prototype, "updatedAt", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ProductLightDTO.prototype, "deletedAt", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productEshop_1.ProductEshopDTO;
}), __metadata("design:type", Array)], ProductLightDTO.prototype, "productEshops", void 0);

exports.ProductLightDTO = ProductLightDTO;

var ProductLandingDTO = function ProductLandingDTO() {
  _classCallCheck(this, ProductLandingDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ProductLandingDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLandingDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLandingDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLandingDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLandingDTO.prototype, "collection", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductLandingDTO.prototype, "url", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return objectProduct_1.ObjectProductDTO;
}), __metadata("design:type", objectProduct_1.ObjectProductDTO)], ProductLandingDTO.prototype, "objectProduct", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureDTO;
}), __metadata("design:type", productPicture_1.ProductPictureDTO)], ProductLandingDTO.prototype, "thumbnail", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return brand_1.BrandLightDTO;
}), __metadata("design:type", brand_1.BrandLightDTO)], ProductLandingDTO.prototype, "brand", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureDTO;
}), __metadata("design:type", Array)], ProductLandingDTO.prototype, "pictures", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return objectProductDimension_1.ObjectProductDimensionDTO;
}), __metadata("design:type", Array)], ProductLandingDTO.prototype, "dimensions", void 0);

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return designer_1.DesignerLightDTO;
}), __metadata("design:type", Array)], ProductLandingDTO.prototype, "designers", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductLandingDTO.prototype, "materialTags", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productSourceFile_1.ProductSourceFileDTO;
}), __metadata("design:type", Array)], ProductLandingDTO.prototype, "sourceFiles", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return objectProductVariation_1.ObjectProductVariationDTO;
}), __metadata("design:type", Array)], ProductLandingDTO.prototype, "variations", void 0);

exports.ProductLandingDTO = ProductLandingDTO;

var ProductCreationDTO = function ProductCreationDTO() {
  _classCallCheck(this, ProductCreationDTO);
};

__decorate([class_validator_1.IsNotEmpty(), class_validator_1.IsString(), __metadata("design:type", String)], ProductCreationDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsEnum(productType_1.ProductType), __metadata("design:type", String)], ProductCreationDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductCreationDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductCreationDTO.prototype, "promoted", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductCreationDTO.prototype, "origin", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductCreationDTO.prototype, "collection", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductCreationDTO.prototype, "suggestedPrice", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return objectProduct_1.ObjectProductCreationDTO;
}), __metadata("design:type", objectProduct_1.ObjectProductCreationDTO)], ProductCreationDTO.prototype, "objectProduct", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return surfaceProduct_1.SurfaceProductCreationDTO;
}), __metadata("design:type", surfaceProduct_1.SurfaceProductCreationDTO)], ProductCreationDTO.prototype, "surfaceProduct", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(), __metadata("design:type", String)], ProductCreationDTO.prototype, "brandId", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductCreationDTO.prototype, "stateId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductCreationDTO.prototype, "designerIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductCreationDTO.prototype, "styleTagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductCreationDTO.prototype, "roomTagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductCreationDTO.prototype, "materialTagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductCreationDTO.prototype, "tagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureCreationDTO;
}), __metadata("design:type", Array)], ProductCreationDTO.prototype, "pictures", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productDocument_1.ProductDocumentCreationDTO;
}), __metadata("design:type", Array)], ProductCreationDTO.prototype, "documents", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPreview_1.ProductPreviewCreationDTO;
}), __metadata("design:type", Array)], ProductCreationDTO.prototype, "previews", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productSourceFile_1.ProductSourceFileCreationDTO;
}), __metadata("design:type", Array)], ProductCreationDTO.prototype, "sourceFiles", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductCreationDTO.prototype, "details", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductCreationDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductCreationDTO.prototype, "brandCode", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUrl({
  require_protocol: true,
  require_valid_protocol: true
}), __metadata("design:type", String)], ProductCreationDTO.prototype, "brandWebsiteUrl", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsDate(), class_transformer_1.Type(function () {
  return Date;
}), __metadata("design:type", Date)], ProductCreationDTO.prototype, "designedDate", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductCreationDTO.prototype, "designersValidated", void 0);

exports.ProductCreationDTO = ProductCreationDTO;

var ProductRelationships = function ProductRelationships() {
  _classCallCheck(this, ProductRelationships);
};

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return designer_1.DesignerLightDTO;
}), __metadata("design:type", Array)], ProductRelationships.prototype, "designers", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productSourceFile_1.ProductSourceFileDTO;
}), __metadata("design:type", Array)], ProductRelationships.prototype, "sourceFiles", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productDocument_1.ProductDocumentDTO;
}), __metadata("design:type", Array)], ProductRelationships.prototype, "documents", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureDTO;
}), __metadata("design:type", Array)], ProductRelationships.prototype, "pictures", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPreview_1.ProductPreviewDTO;
}), __metadata("design:type", Array)], ProductRelationships.prototype, "previews", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return objectProductModelBundle_1.ObjectProductModelBundleDTO;
}), __metadata("design:type", objectProductModelBundle_1.ObjectProductModelBundleDTO)], ProductRelationships.prototype, "objectProductModelBundle", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return tag_1.TagDTO;
}), __metadata("design:type", Array)], ProductRelationships.prototype, "tags", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductRelationships.prototype, "roomTagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductRelationships.prototype, "styleTagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductRelationships.prototype, "materialTagIds", void 0);

exports.ProductRelationships = ProductRelationships;

var ProductRelationshipsDTO =
/*#__PURE__*/
function (_ProductDTO) {
  _inherits(ProductRelationshipsDTO, _ProductDTO);

  function ProductRelationshipsDTO() {
    _classCallCheck(this, ProductRelationshipsDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductRelationshipsDTO).apply(this, arguments));
  }

  return ProductRelationshipsDTO;
}(ProductDTO);

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return designer_1.DesignerLightDTO;
}), __metadata("design:type", Array)], ProductRelationshipsDTO.prototype, "designers", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productSourceFile_1.ProductSourceFileDTO;
}), __metadata("design:type", Array)], ProductRelationshipsDTO.prototype, "sourceFiles", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productDocument_1.ProductDocumentDTO;
}), __metadata("design:type", Array)], ProductRelationshipsDTO.prototype, "documents", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureDTO;
}), __metadata("design:type", Array)], ProductRelationshipsDTO.prototype, "pictures", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPreview_1.ProductPreviewDTO;
}), __metadata("design:type", Array)], ProductRelationshipsDTO.prototype, "previews", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return objectProductModelBundle_1.ObjectProductModelBundleDTO;
}), __metadata("design:type", objectProductModelBundle_1.ObjectProductModelBundleDTO)], ProductRelationshipsDTO.prototype, "objectProductModelBundle", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return tag_1.TagDTO;
}), __metadata("design:type", Array)], ProductRelationshipsDTO.prototype, "tags", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductRelationshipsDTO.prototype, "roomTagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductRelationshipsDTO.prototype, "styleTagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductRelationshipsDTO.prototype, "materialTagIds", void 0);

exports.ProductRelationshipsDTO = ProductRelationshipsDTO;

var ProductExtended = function ProductExtended() {
  _classCallCheck(this, ProductExtended);
};

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductExtended.prototype, "countUnresolvedProblem", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductExtended.prototype, "haveObjectProductModelBundle", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductExtended.prototype, "view", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductExtended.prototype, "download", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ProductExtended.prototype, "lastDownloaded", void 0);

exports.ProductExtended = ProductExtended;

var ProductRelationshipsExtendedDTO =
/*#__PURE__*/
function (_ProductRelationships) {
  _inherits(ProductRelationshipsExtendedDTO, _ProductRelationships);

  function ProductRelationshipsExtendedDTO() {
    _classCallCheck(this, ProductRelationshipsExtendedDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductRelationshipsExtendedDTO).apply(this, arguments));
  }

  return ProductRelationshipsExtendedDTO;
}(ProductRelationshipsDTO);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductRelationshipsExtendedDTO.prototype, "countUnresolvedProblem", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductRelationshipsExtendedDTO.prototype, "haveObjectProductModelBundle", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductRelationshipsExtendedDTO.prototype, "view", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductRelationshipsExtendedDTO.prototype, "download", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ProductRelationshipsExtendedDTO.prototype, "lastDownloaded", void 0);

exports.ProductRelationshipsExtendedDTO = ProductRelationshipsExtendedDTO;

var ProductLightExtendedDTO =
/*#__PURE__*/
function (_ProductLightDTO) {
  _inherits(ProductLightExtendedDTO, _ProductLightDTO);

  function ProductLightExtendedDTO() {
    _classCallCheck(this, ProductLightExtendedDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductLightExtendedDTO).apply(this, arguments));
  }

  return ProductLightExtendedDTO;
}(ProductLightDTO);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductLightExtendedDTO.prototype, "countUnresolvedProblem", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductLightExtendedDTO.prototype, "haveObjectProductModelBundle", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductLightExtendedDTO.prototype, "view", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductLightExtendedDTO.prototype, "download", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ProductLightExtendedDTO.prototype, "lastDownloaded", void 0);

exports.ProductLightExtendedDTO = ProductLightExtendedDTO;

var ProductThumbnailDTO = function ProductThumbnailDTO() {
  _classCallCheck(this, ProductThumbnailDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ProductThumbnailDTO.prototype, "productId", void 0);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ProductThumbnailDTO.prototype, "pictureId", void 0);

exports.ProductThumbnailDTO = ProductThumbnailDTO;

var ProductSuggestionDTO = function ProductSuggestionDTO() {
  _classCallCheck(this, ProductSuggestionDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ProductSuggestionDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductSuggestionDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductSuggestionDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductSuggestionDTO.prototype, "details", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureDTO;
}), __metadata("design:type", productPicture_1.ProductPictureDTO)], ProductSuggestionDTO.prototype, "thumbnail", void 0);

exports.ProductSuggestionDTO = ProductSuggestionDTO;

var ProductLastViewDTO =
/*#__PURE__*/
function (_ProductSuggestionDTO) {
  _inherits(ProductLastViewDTO, _ProductSuggestionDTO);

  function ProductLastViewDTO() {
    _classCallCheck(this, ProductLastViewDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductLastViewDTO).apply(this, arguments));
  }

  return ProductLastViewDTO;
}(ProductSuggestionDTO);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ProductLastViewDTO.prototype, "lastView", void 0);

exports.ProductLastViewDTO = ProductLastViewDTO;

var ProductLightRelationshipsExtendedDTO =
/*#__PURE__*/
function (_ProductLightExtended) {
  _inherits(ProductLightRelationshipsExtendedDTO, _ProductLightExtended);

  function ProductLightRelationshipsExtendedDTO() {
    _classCallCheck(this, ProductLightRelationshipsExtendedDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductLightRelationshipsExtendedDTO).apply(this, arguments));
  }

  return ProductLightRelationshipsExtendedDTO;
}(ProductLightExtendedDTO);

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return designer_1.DesignerLightDTO;
}), __metadata("design:type", Array)], ProductLightRelationshipsExtendedDTO.prototype, "designers", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productSourceFile_1.ProductSourceFileDTO;
}), __metadata("design:type", Array)], ProductLightRelationshipsExtendedDTO.prototype, "sourceFiles", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productDocument_1.ProductDocumentDTO;
}), __metadata("design:type", Array)], ProductLightRelationshipsExtendedDTO.prototype, "documents", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureDTO;
}), __metadata("design:type", Array)], ProductLightRelationshipsExtendedDTO.prototype, "pictures", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPreview_1.ProductPreviewDTO;
}), __metadata("design:type", Array)], ProductLightRelationshipsExtendedDTO.prototype, "previews", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return tag_1.TagDTO;
}), __metadata("design:type", Array)], ProductLightRelationshipsExtendedDTO.prototype, "tags", void 0);

exports.ProductLightRelationshipsExtendedDTO = ProductLightRelationshipsExtendedDTO;

var ProductUpdateDTO = function ProductUpdateDTO() {
  _classCallCheck(this, ProductUpdateDTO);
};

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductUpdateDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsEnum(productType_1.ProductType), __metadata("design:type", String)], ProductUpdateDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductUpdateDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductUpdateDTO.prototype, "promoted", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductUpdateDTO.prototype, "collection", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductUpdateDTO.prototype, "details", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductUpdateDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductUpdateDTO.prototype, "brandCode", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUrl({
  require_protocol: true,
  require_valid_protocol: true
}), __metadata("design:type", String)], ProductUpdateDTO.prototype, "brandWebsiteUrl", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsDate(), class_transformer_1.Type(function () {
  return Date;
}), __metadata("design:type", Date)], ProductUpdateDTO.prototype, "designedDate", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProductUpdateDTO.prototype, "designersValidated", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductUpdateDTO.prototype, "suggestedPrice", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(), __metadata("design:type", String)], ProductUpdateDTO.prototype, "brandId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(), __metadata("design:type", String)], ProductUpdateDTO.prototype, "thumbnail", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductUpdateDTO.prototype, "stateId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsUUID(), __metadata("design:type", String)], ProductUpdateDTO.prototype, "chosenSourceFileId", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductUpdateDTO.prototype, "designerIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductUpdateDTO.prototype, "styleTagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductUpdateDTO.prototype, "roomTagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductUpdateDTO.prototype, "materialTagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.IsUUID(undefined, {
  each: true
}), __metadata("design:type", Array)], ProductUpdateDTO.prototype, "tagIds", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureCreationDTO;
}), __metadata("design:type", Array)], ProductUpdateDTO.prototype, "pictures", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productDocument_1.ProductDocumentCreationDTO;
}), __metadata("design:type", Array)], ProductUpdateDTO.prototype, "documents", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productPreview_1.ProductPreviewCreationDTO;
}), __metadata("design:type", Array)], ProductUpdateDTO.prototype, "previews", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsArray(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return productSourceFile_1.ProductSourceFileCreationDTO;
}), __metadata("design:type", Array)], ProductUpdateDTO.prototype, "sourceFiles", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return objectProduct_1.ObjectProductUpdateDTO;
}), __metadata("design:type", objectProduct_1.ObjectProductUpdateDTO)], ProductUpdateDTO.prototype, "objectProduct", void 0);

exports.ProductUpdateDTO = ProductUpdateDTO;

var ProductPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(ProductPaginationResponse, _pagination_1$Paginat);

  function ProductPaginationResponse() {
    _classCallCheck(this, ProductPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductPaginationResponse).apply(this, arguments));
  }

  return ProductPaginationResponse;
}(pagination_1.PaginationResponse);

__decorate([pagination_1.PaginationData(ProductLightExtendedDTO), __metadata("design:type", Array)], ProductPaginationResponse.prototype, "data", void 0);

exports.ProductPaginationResponse = ProductPaginationResponse;

var ProductPriceMinMax = function ProductPriceMinMax() {
  _classCallCheck(this, ProductPriceMinMax);
};

exports.ProductPriceMinMax = ProductPriceMinMax;

var ProductQuoteDTO = function ProductQuoteDTO() {
  _classCallCheck(this, ProductQuoteDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ProductQuoteDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProductQuoteDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsString(), __metadata("design:type", String)], ProductQuoteDTO.prototype, "details", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.IsNumber(), __metadata("design:type", Number)], ProductQuoteDTO.prototype, "suggestedPrice", void 0);

__decorate([class_validator_1.IsOptional(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return productPicture_1.ProductPictureDTO;
}), __metadata("design:type", productPicture_1.ProductPictureDTO)], ProductQuoteDTO.prototype, "thumbnail", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return brand_1.BrandLightDTO;
}), __metadata("design:type", brand_1.BrandLightDTO)], ProductQuoteDTO.prototype, "brand", void 0);

exports.ProductQuoteDTO = ProductQuoteDTO;